import styled from '@emotion/styled';
import { onClick } from 'helpers/style';

const background = (props) => ({
    background: props.isActive ? props.theme.color.white : props.borderColor,
});

export const Base = styled.button`
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    padding-block: 1px;
    padding-inline: 6px;
    border-radius: 3.5px;
    padding-left: 3px;
    margin: ${(p) => p.theme.padding.small};
    padding: 0;
    padding-left: 3px;
    border: none;
    ${background};
    ${onClick};
    outline: none;
`;

export const Content = styled.div`
    min-width: 75px;
    padding: 5px;
    background-color: ${(p) => (p.isActive ? p.theme.color.white : p.theme.color.grayDark2)};
    color: ${(p) => (p.isActive ? p.theme.color.black : p.theme.color.white)};
    font-weight: lighter;
    font-size: 13px;
    text-align: left;
    border-radius: 3px;
    height: 100%;
    position: relative;
    vertical-align: middle;
    line-height: 38px;
    white-space: nowrap;
    @media (min-width: ${(p) => p.theme.breakpoint.medium}px) {
        line-height: initial;
    }
`;
